var disposed = false
var Component = require("!../../ream/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../ream/node_modules/vue-loader/lib/selector?type=script&index=0!./next-193.vue"),
  /* template */
  require("!!../../ream/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5b5c40b9\"}!../../ream/node_modules/vue-loader/lib/selector?type=template&index=0!./next-193.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/next-193.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] next-193.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b5c40b9", Component.options)
  } else {
    hotAPI.reload("data-v-5b5c40b9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader!./~/v-markdown-loader/_cache/next-193.vue
// module id = 1749
// module chunks = 421